import { clsx } from 'clsx'
import type { ButtonHTMLAttributes } from 'react'
import { useAnal } from '../../../hooks'
import { buttonStyle, buttonType, hidden } from './index.css'

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'reset' | 'bordered'
  analytic?: {
    name: string
    params?: Record<string, string | number | boolean | undefined>
  }
}

export const Button = (props: ButtonProps) => {
  const { analytic, ...buttonProps } = props
  const { logEvent } = useAnal()

  const onClick: React.DOMAttributes<HTMLButtonElement>['onClick'] = (
    event,
  ) => {
    if (props.analytic) {
      logEvent('ui_button_click', {
        name: props.analytic.name,
        ...props.analytic.params,
      })
    }
    if (props.onClick) {
      props.onClick(event)
    }
  }

  return (
    <button
      {...buttonProps}
      type={props.type || 'button'}
      className={clsx(
        buttonStyle,
        props.variant && buttonType[props.variant],
        props.className,
        props.hidden && hidden,
      )}
      hidden={false}
      disabled={props.disabled || props.hidden}
      onClick={onClick}
    />
  )
}
